import theme from './theme'

const createGetter = (dict, base) => {
  const getter = {}
  Object.keys(dict).forEach(item => (
    getter[item] = (props) => base(props)[item]
  ))
  return getter
}

export const colors = createGetter(theme.colors, (props) => props.theme.colors)
export const constants = createGetter(theme.constants, (props) => props.theme.constants)
export const fontFamily = (props) => props.theme.fonts.family
export const fontSize = createGetter(theme.fonts.size, (props) => props.theme.fonts.size)
export const fontWeight = createGetter(theme.fonts.weight, (props) => props.theme.fonts.weight)



// WEBPACK FOOTER //
// ./assets/common/theme/index.js